import { Button } from "reactstrap";
import { exportPendingEmployeePayslipe, exportPendingPayslipes } from "../../../api/payslipes";
import { useResponse } from "../../../hooks/useResponse";

export default function ExportBtn({employeeId}){
    const { loading, setData } = useResponse(employeeId ? exportPendingEmployeePayslipe : exportPendingPayslipes , (res) => {

        let csvContent = "data:text/csv;charset=utf-8," 
        + "Name,Recipient type,IBAN,BIC,Recipient Bank Country,Currency,Amount,Payment Reference\n"
        + res.payslipes.map(e =>  {
            const arr = [
                e.employee.name, 
                "INDIVIDUAL", 
                e.employee.iban || "-", 
                e.employee.bic || "-", 
                e.employee.bank_country || "-", 
                "EUR", 
                e.price, 
                e.id
            ]
            return arr.join(",")
        }).join("\n");

        var encodedUri = encodeURI(csvContent);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "pending.csv");
        document.body.appendChild(link)

        link.click();

    })
    
    function handleExport(){
        setData({type: "add", data: employeeId ? employeeId : null})
    }

    if(loading){
        return(
            <Button>Wait</Button>
        )
    }

    return(
        <Button onClick={handleExport} color="info">Export Pending</Button>
    )
}